module.exports = __webpack_public_path__ + "static/media/Skills Matrix.1ce2268f.png";